module.exports = __webpack_public_path__ + "img/CK.630a04de.svg";